import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores/user'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('@/views/Landing.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/creative',
    name: 'Creative',
    component: () => import('@/views/Creative.vue'),
    meta: { requiresAuth: false, keepAlive: true }, // 创意模板页面允许未登录访问
  },
  {
    path: '/generate/:module?',
    name: 'Generate',
    component: () => import('@/views/Generate/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/tools',
    name: 'Tools',
    component: () => import('@/views/Tools.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/assets',
    name: 'Assets',
    component: () => import('@/views/Assets.vue'),
    meta: { requiresAuth: true, keepAlive: true },
  },
  {
    path: '/membership',
    name: 'Membership',
    component: () => import('@/views/Membership.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/change-model',
    name: 'ChangeModel',
    component: () => import('@/views/ChangeModel.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ai-try-on',
    name: 'AITryOn',
    component: () => import('@/views/AITryOn/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/universal-wear',
    name: 'UniversalWear',
    component: () => import('@/views/UniversalWear.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/Agreement.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/messages',
    name: 'Messages',
    component: () => import('@/views/Messages.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/message/:id',
    name: 'MessageDetail',
    component: () => import('@/views/MessageDetail.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('@/views/My.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/same-style/:id?',
    name: 'SameStyle',
    component: () => import('@/views/SameStyle/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/template-detail/:id',
    name: 'TemplateDetail',
    component: () => import('@/views/TemplateDetail.vue'),
    meta: { requiresAuth: false }, // 允许未登录访问，与创意模板页面一致
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 路由守卫（优化：减少日志输出，提升性能）
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()

  // 检查路由是否需要登录
  if (to.meta.requiresAuth) {
    if (!userStore.isLoggedIn) {
      // 未登录用户只能访问创意模板页面，其他页面跳转到登录页
      next('/login')
      return
    }
  }

  // 如果已登录用户访问登录页面，重定向到首页
  if (to.name === 'Login' && userStore.isLoggedIn) {
    next('/creative')
    return
  }

  next()
})

export default router
